import '../../scss/acf-blocks/acfb-midnight-container.scss';

let $ = jQuery.noConflict();
$(function () {

	if($('.midnight-container').length) {

			const $el = $('.midnight-container .acf-innerblocks-container');
			// const breakpoint = 1080; // lg breakpoint

			function initMidnight() {
				// Verifica che ci siano sezioni con data-midnight prima di inizializzare
				if ( $('[data-midnight]').length === 0 ) {
					return;
				}
				// Attiva midnight solo se viewport >= 1080px
				// if ($(window).width() >= breakpoint) {
					$el.midnight();
					syncCloneVisibility();
					$(window).on('scroll resize', scheduleSync);
				// }
			}

			// Midnight clona l'header per ogni colore di sezione (.midnightElement.default,
			// .light, …) e li alterna con transform: tutti i cloni restano nel DOM, quindi
			// lo screen reader e il Tab trovano il logo due volte. Solo il clone più
			// visibile resta accessibile, gli altri diventano inert + aria-hidden.
			let syncQueued = false;
			let syncTimer = null;

			function scheduleSync() {
				// Midnight aggiorna i transform nel suo requestAnimationFrame: un sync per
				// frame durante lo scroll più uno a scroll fermo, a transform assestati.
				clearTimeout(syncTimer);
				syncTimer = setTimeout(syncCloneVisibility, 150);

				if (syncQueued) {
					return;
				}
				syncQueued = true;
				window.requestAnimationFrame(() => {
					syncQueued = false;
					syncCloneVisibility();
				});
			}

			function visibleFraction(clone) {
				const match = /translateY\((-?[\d.]+)%\)/.exec(clone.style.transform || '');
				return match ? 1 - Math.min(Math.abs(parseFloat(match[1])), 100) / 100 : 1;
			}

			function syncCloneVisibility() {
				const clones = $el.find('> .midnightElement').get();
				if (clones.length < 2) {
					return;
				}

				const active = clones.reduce((best, clone) => (
					visibleFraction(clone) > visibleFraction(best) ? clone : best
				));

				clones.forEach((clone) => {
					const hidden = clone !== active;
					// Non togliere il clone al focus che ci sta sopra: lo si sposta sul clone attivo.
					const hadFocus = hidden && clone.contains(document.activeElement);
					clone.inert = hidden;
					if (hidden) {
						clone.setAttribute('aria-hidden', 'true');
					} else {
						clone.removeAttribute('aria-hidden');
					}
					if (hadFocus) {
						const target = active.querySelector('a, button');
						if (target) {
							target.focus({ preventScroll: true });
						}
					}
				});
			}

			// Inizializza al caricamento
			initMidnight();

			// // Reinizializza al resize
			// $(window).on('resize', function() {
			// 	const viewportWidth = $(window).width();

			// 	if (viewportWidth >= breakpoint) {
			// 		// Attiva midnight se non è già attivo
			// 		if (!$el.data('aerolab.midnight')) {
			// 			$el.midnight();
			// 			$el.attr('data-midnight', 'true');
			// 		}
			// 	} else {
			// 		// Disattiva midnight se la viewport è troppo piccola
			// 		if ($el.data('aerolab.midnight')) {
			// 			$el.data('aerolab.midnight').destroy();
			// 		}
			// 		$el.removeAttr('data-midnight');
			// 	}
			// });

	}


});
